import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../common';
import { DocumentPendingComponent } from './document-pending.component';
import { MaterialModule } from '../../material.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [DocumentPendingComponent],
  imports: [CommonModule, MaterialModule, TranslateModule.forChild({}), PipesModule, SvgIconModule],
  exports: [DocumentPendingComponent],
})
export class DocumentPendingModule {}
